__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/0ba4b4f566e9e3bd909405910860f74518ee865b/_next/";